import {requests} from '../../../utils';
import {IMPERSONATE_URL} from '../../../utils/endpoints';

export const ImpersonateService = {
  impersonateUser: (token: string, userId: string) => requests.post(`${IMPERSONATE_URL}/${token}/${userId}/impersonate`, {}),
};
